import queryString from 'query-string';

const creaateLocationFromHistoryLocation = (location) => ({
    search: location.search,
    query: queryString.parse(location.search),
    pathname: location.pathname
});

export default creaateLocationFromHistoryLocation;
